import * as angular from "angular";
import {IRootScopeService} from "angular";
import {RouteRequestsService} from "./routes-requests.service";
import {RouteModel} from "../models/route.model";

export class RoutesDialogService {

  constructor(private $mdDialog, private routeRequestsService: RouteRequestsService, private $log,
              private $rootScope: IRootScopeService, private systemEventsConfig) {
  }

  generateCustomRoutes(event, serviceAreas) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/generate-custom-routes-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.serviceAreas = serviceAreas;
        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {

          if (form) {
            form.$setSubmitted();
            if (form.$valid) {
              if ($scope.payload) {
                let payload = angular.copy($scope.payload);
                if ($scope.payload.fromArea) {
                  payload.fromArea = payload.fromArea.areaId;
                }
                if ($scope.payload.toArea) {
                  payload.toArea = payload.toArea.areaId;
                }
                $scope.doUpdate(payload);
              }
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editAgentInfo@confirm')
          }

        }


        $scope.doUpdate = (payload) => {
          $scope.loadingState(true);
          self.routeRequestsService.generateRoutes(payload).then(
            () => {
              self.$mdDialog.hide();
            },
            (error) => {
              $scope.loadingState(false);
              self.$log.error('Error while posting generate routes to server, ' +
                'routesDialogService@generateCustomRoutes@doUpdate \n' + error);
            }
          );
        }

        $scope.loadingState = (state) => {
          $scope.loading = state;
          self.$rootScope.$broadcast(self.systemEventsConfig.forms.fieldsetToggle, state);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  routeTimeline(routeId: string, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/route-timeline-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.routeId = routeId

        $scope.cancel = self.$mdDialog.cancel;
      }
    })
  }


  // openAssignDialog(event, serviceIdList, rid, assignToDriver) {
  //   return this.$mdDialog.show({
  //     parent: angular.element(document.body),
  //     template: require('./../views/dialogs/service-assign-dialog.tmpl.html').default,
  //     targetEvent: event,
  //     clickOutsideToClose: true,
  //     fullscreen: true,
  //     controller: ($scope) => {
  //       $scope.serviceIdList = serviceIdList
  //       $scope.rid = rid;
  //       $scope.assignToDriver = assignToDriver;
  //     }
  //   })
  // }

}

angular
  .module('bringoz.admin.routes')
  .service('routesDialogService', RoutesDialogService);
